module.exports = __webpack_public_path__ + "static/img/Ifeyinwa-Frederick.68f13ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/Ifeyinwa-Frederick.png
// module id = NA7j
// module chunks = 0